import { useEffect } from 'react';
import { FlexContainer, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import useTranslation from 'Hooks/useTranslation';
import { useFetchGetUserClabe } from 'Containers/Account/components/AccountProfile/hooks';
import ResultDetailCompensation from 'Containers/Dashboard/components/TaxScreen/components/ResultDetailCompensation';
import SaveClabeBanner from 'Components/SaveClabeBanner';
import ConfirmClabeBanner from 'Components/ConfirmClabeBanner';
import { lottiesPaths } from 'Constants/lottiesPaths';
import { triggerModalForReview } from 'Utils/native';
import { TaxScreenType } from 'Types/common';
import ResultInfo from '../ResultInfo';
import * as Styled from '../styles';

const InReview = ({
  tax: { taxYear, filingInfo, taxReturnResult },
}: TaxScreenType): JSX.Element => {
  const { t } = useTranslation(locizeNS.DASHBOARD);
  const { data } = useFetchGetUserClabe();

  useEffect(() => {
    triggerModalForReview();
  }, []);

  const isCompensation = data?.payWithExternalService;

  return (
    <FlexContainer direction="column" fullHeight fullWidth gap="dimension_16">
      <SaveClabeBanner />
      <Styled.InfoContainer fullWidth fullHeight direction="column" align="center">
        <FlexContainer
          justify="center"
          direction="column"
          align="center"
          gap="dimension_08"
          fullHeight
        >
          <Text size="L_L_S" color="dark" type="headline">
            {taxYear}
          </Text>
          <Text type="paragraphs" size="L_L_M" color="dark" align="center">
            {t('Dashboard.Submitted.message')}
          </Text>
          <Styled.StyledLottie
            options={{ path: lottiesPaths.ON_REVIEW, rendererSetting: { progressiveLoad: true } }}
          />
          {isCompensation ? (
            <ResultDetailCompensation filingInfo={filingInfo} taxReturnResult={taxReturnResult} />
          ) : (
            (filingInfo || taxReturnResult) && (
              <ResultInfo filingInfo={filingInfo} taxReturnResult={taxReturnResult} />
            )
          )}
          <Text type="paragraphs" color="dark" size="M_L_S" align="center">
            {t(`InReview.title`)}
          </Text>
          <Text type="paragraphs" color="dark" size="S_S_S" align="center">
            {t(`InReview.description`)}
          </Text>
          <Styled.ConfirmClabeContainer>
            <ConfirmClabeBanner />
          </Styled.ConfirmClabeContainer>
        </FlexContainer>
      </Styled.InfoContainer>
    </FlexContainer>
  );
};

export default InReview;
